import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchCategories } from "@/lib/api";
import Footer from "@/components/Footer";
import { CATEGORY_CARD } from "@/constants/testIds";

const iconMap = {
  "gamepad-2": "🎮", briefcase: "💼", "graduation-cap": "🎓", music: "🎵",
  "heart-pulse": "❤️", "trending-up": "📈", zap: "⚡", camera: "📷",
  users: "👥", plane: "✈️", "brain-circuit": "🧠", wrench: "🔧",
  "shopping-bag": "🛍️", sparkles: "✨", film: "🎬", shield: "🛡️",
};

export default function Categories() {
  const [cats, setCats] = useState([]);
  useEffect(() => {
    fetchCategories().then(setCats);
  }, []);

  return (
    <>
      <div className="max-w-7xl mx-auto px-6 pt-10">
        <div className="mono text-[10px] uppercase tracking-[0.3em] text-[#00F0FF] mb-3">// full spectrum</div>
        <h1 className="font-heading font-black text-5xl sm:text-6xl uppercase tracking-tighter">
          Every Category
        </h1>
        <p className="text-white/50 mt-2 max-w-lg">
          From cyberpunk racers to zero-log VPNs. Pick your rabbit hole.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-10">
          {cats.map((c) => (
            <Link
              key={c.id}
              to={`/category/${c.id}`}
              data-testid={`${CATEGORY_CARD}-lg-${c.id}`}
              className="glass rounded-2xl p-6 group hover:-translate-y-1 transition-[transform,border-color] duration-300"
              style={{}}
            >
              <div className="flex items-center gap-4">
                <div
                  className="w-14 h-14 rounded-xl flex items-center justify-center text-2xl"
                  style={{ background: `${c.color}18`, border: `1px solid ${c.color}40` }}
                >
                  {iconMap[c.icon] || "◆"}
                </div>
                <div>
                  <div className="font-heading font-black text-xl uppercase tracking-tight">{c.name}</div>
                  <div className="mono text-xs text-white/50">{c.count} apps live</div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
